const TypeContrat = {
	SANTE: 'SANTE',
	PREVOYANCE: 'PREVOYANCE',
	SANTE_PREVOYANCE: 'SANTE & PREVOYANCE'
}

export default TypeContrat
